import { getMinValue } from './getMinValue';
import { getMaxValue } from './getMaxValue';
export const setUpdatedDetailsOptions = (masterChartOptions, currentFactorTimeseriesData) => (Object.assign(Object.assign({}, masterChartOptions), { yAxis: Object.assign({ labels: { enabled: false }, min: getMinValue(currentFactorTimeseriesData) * 1.3, max: getMaxValue(currentFactorTimeseriesData) * 1.3 }, masterChartOptions.yAxis), series: currentFactorTimeseriesData.map(({ data, name }) => ({
        type: 'line',
        marker: {
            enabled: false,
        },
        name,
        pointInterval: 24 * 3600 * 1000,
        pointStart: data[0][0],
        data,
    })) }));
//# sourceMappingURL=setUpdateDetailsOptions.js.map